import { ApplicationDto } from "./application.dto";
import { UserDto } from "./user.dto";

enum CreditTypes {
  FORECASTING = "forecasting",
  AI_AUDIT = "ai_audit",
  DEBTOR_SUMMARY = "debtor_summary",
  INTEL = "intel",
  CASE_SPLIT = "case_llm",
  NEGOTIATION_MAIL = "negotiation_mail",
}

enum ConsumptionTypes {
  REFUND = "refund",
  USED = "used",
  RECHARGE = "recharge",
}

export type LogsType = {
  date: Date;
  type?: CreditTypes;
  consumption_type?: ConsumptionTypes;
  amount: number;
  payment?: number;
  description?: string;
  user?: UserDto;
  application?: ApplicationDto;
};

export type T_Credits = {
  _id: string;
  createdAt: Date;
  updatedAt: Date;
  credits: number;
  logs?: LogsType[];
  total_used?: number;
  is_active?: boolean;
};

export { ConsumptionTypes, CreditTypes };
